import { useEffect } from "react";

const SITE = "https://netforgesols.com";

function upsertMeta(key, value, attr = "name") {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

/**
 * Sets per-page <title>, meta description, canonical + OG/Twitter tags.
 * Renders nothing.
 */
export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    if (title) document.title = title;
    upsertMeta("description", description);
    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:url", url, "property");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path]);

  return null;
};
